<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ id > 0 ? "Editar" : "Adicionar" }} Territórios
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Nome"
              name="tipo"
              type="text"
              v-model="territorio.nome"
              required
              :rules="rules"
              background-color="white"
              @blur="changeNomeFantasia"
            />
          </v-col>

          <v-col>
            <v-text-field
              v-model="territorio.inicio"
              v-mascara="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
              :rules="rulesData"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="territorio.nomeFantasia"
              label="Nome Fantasia"
            ></v-text-field>
          </v-col>

          <v-col>
            <ComboboxTerritoriosStatusTerritorio
              :value="territorio"
            ></ComboboxTerritoriosStatusTerritorio>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <combobox-municipio-territorio
              :value="territorio"
              :multiple="true"
              :clearable="true"
            ></combobox-municipio-territorio>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="w-100 text-center title-insert">Iniciativas</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex">
            <div class="addIniciativa">
              <modal-adicionar-iniciativa
                :dialog="showModalAddIniciativa"
                :title="'Adicionar Iniciativas'"
                @onSave="addIniciativa"
                :iniciativasSelecionadas="territorio.territoriosIniciativas"
              ></modal-adicionar-iniciativa>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="delete">
            <v-btn
              outlined
              color="error"
              class="mr-3"
              :disabled="!territorio.territoriosIniciativas.length"
              @click="removeAllPermission()"
            >
              <v-icon>mdi-trash-can-outline</v-icon> Deletar Todos
            </v-btn>
            <v-btn
              color="error"
              class="mr-3"
              :disabled="!selectionItems.length"
              @click="removePermission()"
            >
              <v-icon>mdi-trash-can-outline</v-icon> Deletar Selecionados
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          style="
            row-gap: 15px;
            column-gap: 15px;
            justify-content: space-around;
            margin-bottom: 10px;
          "
        >
          <v-col v-if="!territorio.territorioIniciativaFiltrado.length">
            Nenhuma Iniciativa
          </v-col>
          <template v-else>
            <div
              v-for="territorioIniciativa in territorio.territorioIniciativaFiltrado"
            >
              <v-row>
                <v-col>
                  <v-card outlined>
                    <v-card-title>
                      <v-col>
                        {{ territorioIniciativa.nomeIniciativa }}
                      </v-col>
                      <v-col cols="1">
                        <v-checkbox
                          color="primary"
                          v-model="territorioIniciativa.selection"
                          @change="
                            territorio.territoriosIniciativas =
                              territorio.territoriosIniciativas.map(
                                (item, i) => {
                                  if (index === i) {
                                    item.selection = $event;
                                  }
                                  return item;
                                }
                              )
                          "
                        >
                        </v-checkbox>
                      </v-col>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <div>
                            <v-text-field
                              v-model="territorioIniciativa.inicio"
                              v-mascara="'##/##/####'"
                              label="Data Início"
                              placeholder="00/00/0000"
                              outlined
                              hide-details="auto"
                              :rules="rulesData"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="territorioIniciativa.fim"
                            v-mascara="'##/##/####'"
                            label="Data Fim"
                            placeholder="00/00/0000"
                            outlined
                            hide-details="auto"
                            :rules="rulesData"
                          ></v-text-field>
                        </v-col>

                        <v-col>
                          <div>
                            <ComboboxTerritoriosStatus
                              :value="territorioIniciativa"
                              outlined
                            ></ComboboxTerritoriosStatus>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <div>
                            Iniciativa implementada em todos os
                            {{ isGov ? "projetos" : "municípios" }} do
                            Território?
                          </div>
                          <v-radio-group
                            v-model="territorioIniciativa.todos"
                            row
                            :rules="[requiredBoolean]"
                            @change="
                              (e) => {
                                if (e) territorioIniciativa.excecao = null;
                              }
                            "
                          >
                            <v-radio
                              label="Sim"
                              :key="1"
                              :value="true"
                            ></v-radio>
                            <v-radio
                              label="Não"
                              :key="2"
                              :value="false"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="territorioIniciativa.excecao"
                            :label="`Se NÃO, informar os ${
                              isGov ? 'projetos' : 'municípios'
                            } que são exceção`"
                            outlined
                            hide-details="auto"
                            :rules="
                              territorioIniciativa.todos == false
                                ? [required]
                                : [true]
                            "
                            :disabled="territorioIniciativa.todos"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <ComboboxTerritoriosReponsaveis
                            :filter="territorioIniciativa"
                          ></ComboboxTerritoriosReponsaveis>
                        </v-col>

                        <v-col>
                          <v-currency-field
                            label="Valor estimado total"
                            :prefix="'R$'"
                            outlined
                            hide-details="auto"
                            v-model="territorioIniciativa.custo"
                          />
                        </v-col>
                        <v-col>
                          <div>
                            <v-text-field
                              v-model="territorioIniciativa.atores"
                              label="Atores"
                              outlined
                              hide-details="auto"
                            ></v-text-field>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-textarea
                            label="Justificativa/Observações de status"
                            v-model="territorioIniciativa.observacoes"
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        color="error"
                        class="mr-3"
                        @click="removeOnePermission(territorioIniciativa)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-row>
        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ComboboxMunicipioTerritorio from "@/modules/gestao-territorios/components/territorios/ComboboxMunicipioTerritorios";
import ModalAdicionarIniciativa from "@/modules/gestao-territorios/components/territorios/ModalAdicionarIniciativa";
import ComboboxTerritoriosCategorias from "@/modules/gestao-territorios/components/categorias/ComboboxTerritoriosCategorias";
import moment from "moment";
import { territorioAPI } from "@/modules/gestao-territorios/API/territorioAPI";
import { dataRegexValidatior } from "@/helpers/validator";
import ComboboxTerritoriosStatus from "@/modules/gestao-territorios/components/status/ComboboxTerritorioIniciativaStatus";
import ComboboxTerritoriosStatusTerritorio from "@/modules/gestao-territorios/components/status/ComboboxTerritoriosStatus";

import { required, requiredBoolean } from "@/helpers/validator";
import ComboboxTerritoriosReponsaveis from "../responsaveis/ComboboxTerritoriosReponsaveis.vue";
import Swal from "sweetalert2";

export default {
  components: {
    ComboboxMunicipioTerritorio,
    ModalAdicionarIniciativa,
    ComboboxTerritoriosCategorias,
    ComboboxTerritoriosStatus,
    ComboboxTerritoriosReponsaveis,
    ComboboxTerritoriosStatusTerritorio,
  },
  data() {
    return {
      territorio: {
        territoriosIniciativas: [],
        territorioIniciativaFiltrado: [],
      },
      headers: [
        { text: "", value: "selection" },
        { text: "Eixo", value: "nomeEixo" },
        { text: "Iniciativa", value: "nomeIniciativa" },
        { text: "Datas", value: "date" },
        { text: "Ação", value: "action", width: "10%" },
      ],
      isEdit: false,
      allSelected: false,
      tabType: this.$route.params.tab,
      id: this.$route.params.id,
      rules: [(v) => !!v || "Campo Obrigatório"],
      required: required,
      requiredBoolean: requiredBoolean,
      rulesData: [
        (v) => {
          if (!v) return "Campo Obrigatório";
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
      rulesDataB: [
        (v) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
      showModalAddIniciativa: false,
      eixosFiltros: {},
      search: "",
      userTeste: JSON.parse(localStorage.getItem("user")),
    };
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isGov"]),

    selectionItems() {
      return this.territorio.territoriosIniciativas.filter(
        (item) => item.selection
      );
    },
    notSelectionItems() {
      return this.territorio.territoriosIniciativas.filter(
        (item) => !item.selection
      );
    },
  },
  mounted() {
    if (this.id > 0) {
      this.setLoading(true);
      territorioAPI
        .get(this.id)
        .then(({ data }) => {
          var territoriosIniciativas = data.territoriosIniciativas;

          if (territoriosIniciativas && territoriosIniciativas.length) {
            territoriosIniciativas = territoriosIniciativas.map((val) => {
              return {
                ...val,
                ...val.eixo,
                ...val.iniciativa,
                inicio: val.inicio
                  ? moment(val.inicio).format("DD/MM/YYYY")
                  : null,
                fim: val.fim ? moment(val.fim).format("DD/MM/YYYY") : null,
                responsaveis:
                  (val.responsaveisId &&
                    val.responsaveisId
                      .split(",")
                      .map((item) => parseInt(item))) ||
                  [],
                statusId: val.statusIniciativaId,
              };
            });
          }
          this.territorio = {
            municipioId:
              data.territoriosMunicipios &&
              data.territoriosMunicipios.length > 0
                ? data.territoriosMunicipios.map((item) => item.municipioid)
                : [],
            territorioIniciativaFiltrado: territoriosIniciativas,
            territoriosIniciativas: territoriosIniciativas,
            nome: data.nome,
            inicio: moment(data.inicio).format("DD/MM/YYYY"),
            nomeFantasia: data.nomeFantasia,
            statusId: data.statusId,
          };

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Territórios");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    changeNomeFantasia() {
      if (!this.territorio.nomeFantasia) {
        this.territorio.nomeFantasia = this.territorio.nome;
        this.$forceUpdate();
      }
    },
    changeEixo(id) {
      if (id.eixoId) {
        if (this.territorio.territorioIniciativaFiltrado.length > 0) {
          this.territorio.territorioIniciativaFiltrado =
            this.territorio.territorioIniciativaFiltrado
              .filter((item) => item.territorioEixoId == id.eixoId)
              .map((item) => ({ ...item, selection: false }));
        }
      } else {
        this.territorio.territorioIniciativaFiltrado =
          this.territorio.territoriosIniciativas;
      }
    },
    addIniciativa(val) {
      this.territorio.territoriosIniciativas = [
        ...this.territorio.territoriosIniciativas,
        ...val,
      ];

      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;
    },
    goToList() {
      this.$router.push(`/gestao-territorios/${this.tabType}`);
    },
    removeAllPermission() {
      this.territorio.territoriosIniciativas = [];
      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;
    },
    removePermission() {
      this.territorio.territoriosIniciativas = this.notSelectionItems;
      this.territorio.territorioIniciativaFiltrado =
        this.territorio.territoriosIniciativas;
    },
    removeOnePermission(item) {
      this.territorio.territoriosIniciativas.forEach((val, index) => {
        if (item.territorioIniciativaId == val.territorioIniciativaId) {
          this.territorio.territoriosIniciativas.splice(index, 1);
        }
      });

      this.territorio.territorioIniciativaFiltrado.forEach((val, index) => {
        if (item.territorioIniciativaId == val.territorioIniciativaId) {
          this.territorio.territorioIniciativaFiltrado.splice(index, 1);
        }
      });
    },
    validateIniciativa() {
      let errors = [];
      this.territorio.territoriosIniciativas.forEach((item) => {
        if (
          moment(item.fim, "DD/MM/YYYY HH:mm").isBefore(
            moment(item.inicio, "DD/MM/YYYY HH:mm")
          )
        ) {
          errors.push(
            `<div style="margin-bottom:10px;"> ${item.nomeIniciativa} - Data final menor que data inicial</div>`
          );
        }
      });

      return errors;
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;

      if (
        this.territorio.territoriosIniciativas &&
        this.territorio.territoriosIniciativas.length > 0
      ) {
        if (this.validateIniciativa().length) {
          Swal.fire({
            title: "Iniciativa inválida",
            html: this.validateIniciativa(),
            confirmButtonText: "Ok",
          });

          return;
        }

        this.territorio.territoriosIniciativas =
          this.territorio.territoriosIniciativas.map((item) => ({
            ...item,
            inicio:
              (item.inicio &&
                moment(item.inicio, "DD/MM/YYYY").toISOString()) ||
              null,
            fim:
              (item.fim && moment(item.fim, "DD/MM/YYYY").toISOString()) ||
              null,
            usuarioId: this.userTeste.usuarioId,
            iniciativaId: item.territorioIniciativaId,
            statusIniciativaId: item.statusId,
            responsaveisId:
              item.responsaveis &&
              item.responsaveis.length &&
              item.responsaveis.join(","),
          }));
      }

      const territorio = {
        municipioId:
          this.territorio.municipioId && this.territorio.municipioId.length
            ? this.territorio.municipioId
            : null,
        nome: this.territorio.nome,
        inicio: moment(this.territorio.inicio, "DD/MM/YYYY").toISOString(),
        usuarioId: this.userTeste.usuarioId,
        territoriosIniciativas: this.territorio.territoriosIniciativas.length
          ? this.territorio.territoriosIniciativas
          : null,
        statusId: this.territorio.statusId,
        nomeFantasia: this.territorio.nomeFantasia,
      };
      this.setLoading(true);

      if (this.id > 0) {
        territorio.territorioId = parseInt(this.id);
        territorioAPI
          .update(territorio)
          .then(() => {
            this.$notification.success("Território editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Território");
            console.log("Erro no submit ", err);
          });
      } else {
        territorioAPI
          .create(territorio)
          .then(() => {
            this.$notification.success("Território criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Território");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.addIniciativa {
  margin-left: auto;
}
.iniciativas {
  justify-content: center;
  align-items: center;
}
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}
.dates {
  column-gap: 20px;
}
</style>
